var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#DC2418"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.64116 11.7422L13.3495 7.03385C13.4606 6.92274 13.5902 6.86719 13.7384 6.86719C13.8865 6.86719 14.0162 6.92274 14.1273 7.03385C14.2384 7.14497 14.2939 7.277 14.2939 7.42997C14.2939 7.58293 14.2384 7.71478 14.1273 7.82552L9.03005 12.9366C8.91894 13.0477 8.78931 13.1033 8.64116 13.1033C8.49301 13.1033 8.36338 13.0477 8.25227 12.9366L5.86338 10.5477C5.75227 10.4366 5.69894 10.3048 5.70338 10.1522C5.70783 9.99959 5.76579 9.86756 5.87727 9.75608C5.98875 9.64459 6.12079 9.58904 6.27338 9.58941C6.42597 9.58978 6.55783 9.64533 6.66894 9.75608L8.64116 11.7422Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIcon);
export default __webpack_public_path__ + "static/media/checkIcon.67292b39c1df7f93bf84b4367bf0ce25.svg";
export { ForwardRef as ReactComponent };